import NavIcon from './NavIcon';

const NAV_ICON = { Home: 'home', About: 'person', Projects: 'folder_open', Career: 'timeline', Contact: 'email' };

export default function MobileNav({ navItems, mobileOpen, setMobileOpen, scrollTo, setOpenProject }) {
  return (
    <>
      <div className="mobile-header">
        <div className="mobile-brand">
          <div className="mobile-brand-dot" />
          <span className="mobile-brand-name">Ismil Nadaf</span>
        </div>
        <button
          className={`hamburger${mobileOpen ? ' open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {mobileOpen && (
        <div className="mobile-nav-overlay">
          <div className="mobile-nav-overlay-header">
            <div className="mobile-brand">
              <div className="mobile-brand-dot" />
              <span className="mobile-brand-name">Ismil Nadaf</span>
            </div>
            <button className="hamburger open" onClick={() => setMobileOpen(false)} aria-label="Close menu">
              <span /><span /><span />
            </button>
          </div>
          <nav>
            {navItems.map((item) => (
              <button
                key={item.id}
                className="mobile-nav-btn"
                onClick={() => { setMobileOpen(false); setOpenProject(null); scrollTo(item.id); }}
              >
                <NavIcon name={NAV_ICON[item.label] || 'home'} size={20} color="#1A1A1A" style={{ opacity: 0.6, flexShrink: 0 }} />
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
